import React, { Suspense, Fragment } from "react";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { useSelector } from 'react-redux';

// Routes
import Components from "modules/components";
import { ability } from "app/services/permissions/ability";

// Middleware
import ProtectedAuthRoute from "app/layouts/protected";

// Layouts
import AdminLayout from "app/layouts/Admin";
import PublicLayout from "app/layouts/Public";

// Components
import Page404 from "modules/Error/404";
import PageLoader from "app/components/PageLoader";
import Toast from "app/components/Toast";

// Styles
import "assets/scss/theme.scss";
// import "react-toastify/dist/ReactToastify.min.css";
import 'react-toastify/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";

const App = () => {

  const { user: User, isLogged } = useSelector((state) => state.auth);

  const authProps = {
    User,
    UserRole: User.role,
    Company: User.company,
    isLogged,
  };
  console.log('Generate:AuthProps', authProps)

  return (
    <Fragment>
  <Toast />

      <Suspense fallback={<PageLoader blocker={true} />}>
        <Router>
          <Routes>
            {Components.map((app, key) => {
              const isPublic = app.public === true;
              // If the component defines a permission we must check it dynamically.
              // Previously this used a hardcoded 'page:account.index' value which
              // caused every permissioned route to check the same rule. That made
              // administrators unable to access other permissions.
              const hasPermission = app.permission
                ? (app.permission === true ? true : ability.can('access', app.permission))
                : true;
              const ComponentElement = isPublic ? (
                <PublicLayout>
                  <app.component />
                </PublicLayout>
              ) : (
                <ProtectedAuthRoute {...authProps}>
                  <AdminLayout>
                    {hasPermission ? (
                      <app.component {...authProps} />
                    ) : (
                      <Page404 />
                    )}
                  </AdminLayout>
                </ProtectedAuthRoute>
              );

              return (
                <Route key={key} path={app.path} element={ComponentElement} />
              );
            })}

            <Route path="*" element={<Page404 />} />
          </Routes>
        </Router>
      </Suspense>
    </Fragment>
  );
};

export default App;